<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card class="transparent">
          <v-card-title>
            New Channel
          </v-card-title>
          <v-tabs
            v-model="tab"
            background-color=""
          >
            <v-tab
              v-for="t in tabs"
              :key="t.name"
            >
              {{ t.name }}
            </v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="tab"
            class="transparent"
          >
            <v-tab-item class="transparent">
              <v-row>
                <v-col cols="12">
                  <base-card>
                    <v-card-text>
                      <v-row>
                        <v-col
                          cols="12"
                          md="8"
                        >
                          <v-text-field
                            v-model.trim="newChannel.name"
                            :rules="rules.nameRules"
                            :counter="255"
                            label="Name*"
                            required
                          />
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model.trim="newChannel.company"
                            label="Owner company"
                            required
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </base-card>
                </v-col>
                <v-col cols="12">
                  <base-card>
                    <v-card-text>
                      <v-form
                        ref="form"
                      >
                        <v-text-field
                          v-model.trim="newChannel.url"
                          prepend-icon="mdi-link"
                          label="Source URL*"
                          placeholder="https://"
                          required
                        />

                        <v-textarea
                          v-model.trim="newChannel.shortDescription"
                          label="Short description"
                          rows="1"
                          auto-grow
                        />

                        <v-textarea
                          v-model.trim="newChannel.longDescription"
                          label="Long description"
                          rows="1"
                          auto-grow
                        />
                      </v-form>
                      <v-autocomplete
                        v-model="newChannel.genres"
                        :items="genres"
                        return-object
                        small-chips
                        label="Genres"
                        item-text="name"
                        multiple
                      />
                    </v-card-text>
                  </base-card>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="m-r-20 p-b-20">
                    <v-spacer />
                    <v-btn
                      :loading="saving"
                      :disabled="!isFormValid || saving"
                      color="success"
                      @click="saveChannel()"
                    >
                      <v-icon left>
                        mdi-content-save
                      </v-icon>
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item class="transparent">
              <base-card class="transparent">
                <v-card-text>logos</v-card-text>
              </base-card>
            </v-tab-item>
          </v-tabs-items>
        </base-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { processGenre, thirdPartyChannelToJsonAPI } from '@/store/converters'

  export default {
    metaInfo: {
      title: 'Distribution Packages',
    },
    data () {
      return {
        tab: null,
        tabs: [
          { name: 'Basic Info' },
          { name: 'Logos' },
        ],
        genres: [],
        newChannel: {
          name: '',
          company: '',
          shortDescription: '',
          longDescription: '',
          url: '',
          genres: [],
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 1024) || 'Name must be less than 1024 characters',
          ],
        },
        saving: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (!(this.newChannel.name.length >= 3 && this.newChannel.name.length <= 255)) {
          return false
        }
        if (!this.newChannel.url.startsWith('http')) {
          return false
        }
        return true
      },
      defaultIcon () {
        return '/images/no_logo.jpeg'
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$store.commit('setPageLoader')

        const genreArgs = {
          'category[eq]': 'common',
        }
        const genreReq = this.$store.dispatch('genres', genreArgs)

        return Promise.all([genreReq])
          .then((res) => {
            const genres = res[0] || []
            this.genres = genres.map((g) => processGenre(g))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'ThirdPartyChannelsPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      saveChannel () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')

        const newChannel = thirdPartyChannelToJsonAPI(this.newChannel)

        this.$store.dispatch('createThirdPartyChannel', newChannel)
          .then((channel) => {
            this.$store.commit('showSnackbar', {
              text: 'The channel has been successfully added',
              timeout: 3000,
              color: 'success',
            })
            this.$router.push({
              name: 'ThirdPartyChannel',
              params: {
                channel_id: channel.id,
              },
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
    },
  }
</script>

<style>
</style>
